// extracted by mini-css-extract-plugin
export default {"price":"Voa-z","onSale":"Woa-z","msrpLabelPrice":"Xoa-z","msrpLabel":"Yoa-z","originalPrice":"Zoa-z"};